import moment from "moment";
import { harvestYearDetail } from "../../config/harvestYearDetail";
import { globalApiHandler } from "../../services/services";
import { calculateDays, formatDate } from "../../utils/DateFormatter";

export const RISKMGMT = {
  list: {
    success: "RISKMGMT_GET_ALL_SUCCESS",
    error: "RISKMGMT_GET_ALL_ERROR"
  },
  unallocatedlist: {
    success: "RISKMGMT_GET_UNALLOCATED_SUCCESS",
    error: "RISKMGMT_GET_UNALLOCATED_ERROR"
  },
  internallist: {
    success: "RISKMGMT_GET_INTERNAL_SUCCESS",
    error: "RISKMGMT_GET_INTERNAL_ERROR"
  },
  ticketList: {
    success: "RISKMGMT_GET_RELATED_TICKETS_SUCCESS",
    error: "RISKMGMT_GET_RELATED_TICKETS_ERROR"
  },
  internalInventoryDest : {
    start: "INVENTORY_GET_DEST_START",
    success: "INVENTORY_GET_DEST_SUCCESS",
    error: "INVENTORY_GET_DEST_ERROR"
  },
  inventory: {
    success : "INVENTORY_SUCCESS",
    error: "INVETORY_ERROR"
  }
};

export const riskMgmtListAction = (farmId, harvestYear=harvestYearDetail().name) => {
  let url = `/ntrac/risk/management/farmId/${farmId}?harvestYear=${harvestYear}`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const currentDate = response.data.timestamp;
        let data = response.data.data.riskManagementDTOS;
        const summaryData = response.data.data;
        data.map(item => {
          item.daysLeft = calculateDays(
            new Date(item.maturityDate).getTime() -
              new Date(formatDate(currentDate)).getTime()
          );
          item.maturityDate = moment(item.maturityDate).format("ll");
          item.commodityName = `${item.commodityName} (${item.commodityVarietyName})`;
        });
        data.contractsBehindScheduled = summaryData.contractsBehindScheduled;
        data.contractsCompleted = summaryData.contractsCompleted;
        dispatch({ type: RISKMGMT.list.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const unallocatedTicketsListAction = (farmId, harvestYear=harvestYearDetail().name) => {
  let url = `/ntrac/risk/management/farmId/${farmId}/unallocatedTickets?harvestYear=${harvestYear}`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        let data = response.data.data;
        data.map(item => {
          item.loadDate = moment(item.loadDate).format("ll");
          item.stage = item.status ? item.status : "In-transit";
          item.commodityName = `${item.commodityName} (${item.commodityVarietyName})`;
        });
        dispatch({ type: RISKMGMT.unallocatedlist.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const internalTicketsListAction = (farmId, harvestYear=harvestYearDetail().name) => {
  let url = `/ntrac/risk/management/farmId/${farmId}/internal?harvestYear=${harvestYear}`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        let data = response.data.data;
        data.map(item => {
          item.loadDate = moment(item.loadDate).format("ll");
          item.stage = item.status ? item.status : "In-transit";
          item.commodityName = `${item.commodity} (${item.commodityVariety})`;
        });
        dispatch({ type: RISKMGMT.internallist.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const riskMgmtTicketListAction = id => {
  let url = `/ntrac/risk/management/${id}`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.loadDate = moment(item.loadDate).format("lll");
          //TODO: This need to be updated once reconcilation part is done
          item.quantity = item.fieldEstimatedLoadBushels;
          item.delivered = item.receivedNetBushels;
          item.balance = item.balance;
          item.stage = item.status ? item.status : "In-transit";
        });
        dispatch({ type: RISKMGMT.ticketList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const riskMgmtInternalTicketListAction = queryString => {
  let url = `/ntrac/risk/management/allTicketsOfInternalInventoryData?${queryString}`;
  return dispatch => {
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.loadDate = moment(item.loadDate).format("lll");
          //TODO: This need to be updated once reconcilation part is done
          item.quantity = item.fieldEstimatedLoadBushels;
          item.delivered = item.receivedNetBushels;
          item.balance = item.balance;
          item.stage = item.status ? item.status : "In-transit";
        });
        dispatch({ type: RISKMGMT.ticketList.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const inventoryDestinationList = queryString => {
  let url = `/ntrac/risk/management/allTicketsOfInternalInventoryData?${queryString}`;
  return dispatch => {
    dispatch({ type: RISKMGMT.internalInventoryDest.start, data:"" });
    return globalApiHandler(url, "get", {})
      .then(response => {
        let data = response.data.data;
        console.log(data)
        data.map(item => {
        //   item.loadDate = moment(item.loadDate).format("ll");
          item.status = item.status && item.status.name ? item.status.name : "In-transit";
        //   item.commodityName = `${item.commodity} (${item.commodityVariety})`;
        });
        dispatch({ type: RISKMGMT.internalInventoryDest.success, data });
        return true
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return false
      });
  };
};


// WEBPACK FOOTER //
// ./src/modules/riskmanagement/action.js